import classNames from 'classnames';
import React from 'react';
import { DropZoneComponent } from 'src/common/components/drop-zone/component';
import { UploadCloudLightIcon } from 'src/monet/icons';

interface Props {
  onClick: () => void;
  onFileDrop: (files: File[]) => void;
}

// will be renamed and reused soon on the library page
export const StepEditorContentFileDropZone = ({ onFileDrop, onClick }: Props) => {
  return (
    <DropZoneComponent onFileDrop={onFileDrop} preventResetStyleOnFileDrop>
      {(dragging) => (
        <div className='relative w-full'>
          <div
            className={classNames('w-full h-full transition-opacity', {
              'opacity-0': dragging,
              'opacity-100': !dragging,
            })}
          />
          <div
            onClick={onClick}
            className={classNames(
              'absolute gap-2 inset-0 flex items-center justify-center',
              'cursor-pointer text-bedrock-p px-3 w-full',
              'transition-colors rounded-lg border-dashed border-2',
              {
                'border-bedrock-brand-secondary bg-bedrock-brand-secondary/transparent text-bedrock-brand-secondary':
                  dragging,
                'border-bedrock-gray-medium bg-bedrock-light-gray text-bedrock-black': !dragging,
              }
            )}
          >
            <UploadCloudLightIcon className='shrink-0' />
            <span>{dragging ? <>Drop it, like its hot</> : <>Drag and drop or click to upload</>}</span>
          </div>
        </div>
      )}
    </DropZoneComponent>
  );
};
